<div class="draw-container">
  <div class="draw-description">
    <h3 [ngClass]="{ hidden: (model && model.data) || !isEmpty() }">{{ description | translate }}</h3>
    <div *ngIf="model.pending">
      <app-loading [isRadial]="true"></app-loading>
    </div>
  </div>
  <a class="clear-btn" (click)="clear()" *ngIf="model && model.data && !model.pending">
    <svg class="icon-svg">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-clear"></use>
    </svg>
  </a>
  <div class="draw-wrapper">
    <canvas #canvas></canvas>
    <div class="draw-line"></div>
  </div>
</div>
